// removed by extract-text-webpack-plugin
module.exports = {"header":"PaymentInformation__header--6v6Ze","label":"PaymentInformation__label--3ln6x","subscriptionStatus":"PaymentInformation__subscriptionStatus--1Vvnk","moreOptionsLinks":"PaymentInformation__moreOptionsLinks--2Ybus"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/PaymentInformation/PaymentInformation.css
// module id = 5sIN
// module chunks = 47